<template>
  <div class="border">
    <ul>
      <li>
        <el-select v-model="ruleData.ruleField">
          <el-option
            v-for="item in ruleOptions"
            :label="item.fieldName"
            :key="item.fieldCode"
            :value="item.fieldCode"
          ></el-option>
        </el-select>
      </li>
      <li>
        <el-select v-model="ruleData.ruleOperator">
          <el-option
            v-for="item in ruleOperators"
            :label="item.value"
            :key="item.key"
            :value="item.key"
          ></el-option>
        </el-select>
      </li>
      <li class="is-long">
        <el-input v-model="ruleData.ruleValue" v-if="ruleValueType==''||ruleValueType=='str'" :style="{ visibility: showRuleValue ? 'visible' : 'hidden' }"></el-input>
        <el-input-number v-model="ruleData.ruleValue" controls-position="right" v-if="ruleValueType=='num'" :style="{ visibility: showRuleValue ? 'visible' : 'hidden' }"></el-input-number>
        <el-input v-model="ruleData.ruleValue" type="textarea" v-if="ruleValueType=='txt'" :style="{ visibility: showRuleValue ? 'visible' : 'hidden' }"></el-input>
        <el-select v-model="ruleData.ruleValues" :multiple="true" v-if="ruleValueType=='opts'&&ruleData.ruleField=='accountTag'" :style="{ visibility: showRuleValue ? 'visible' : 'hidden' }">
          <el-option
            v-for="item in accountTags"
            :label="item.value"
            :key="item.key"
            :value="item.key"
          ></el-option>
        </el-select>
        <el-select v-model="ruleData.ruleValues" :multiple="true" v-if="ruleValueType=='opts'&&ruleData.ruleField=='accountLevel'" :style="{ visibility: showRuleValue ? 'visible' : 'hidden' }">
          <el-option
            v-for="item in accountLevels"
            :label="item.value"
            :key="item.key"
            :value="item.key"
          ></el-option>
        </el-select>
        <el-select v-model="ruleData.ruleValues" :multiple="true" v-if="ruleValueType=='opts'&&ruleData.ruleField=='accountStatus'" :style="{ visibility: showRuleValue ? 'visible' : 'hidden' }">
          <el-option
            v-for="item in accountStatuses"
            :label="item.value"
            :key="item.key"
            :value="item.key"
          ></el-option>
        </el-select>
        <el-select v-model="ruleData.ruleValues" :multiple="true" v-if="ruleValueType=='opts'&&ruleData.ruleField=='registerSource'" :style="{ visibility: showRuleValue ? 'visible' : 'hidden' }">
          <el-option
            v-for="item in registerSources"
            :label="item.value"
            :key="item.key"
            :value="item.key"
          ></el-option>
        </el-select>
        <el-select v-model="ruleData.ruleValues" :multiple="true" v-if="ruleValueType=='opts'&&ruleData.ruleField=='businessType'" :style="{ visibility: showRuleValue ? 'visible' : 'hidden' }">
          <el-option
            v-for="item in businessTypes"
            :label="item.value"
            :key="item.key"
            :value="item.key"
          ></el-option>
        </el-select>
        <br>
        <span v-if="annotationTxt">{{ annotationTxt }}</span>
      </li>
      <li>
        <div class="icon-area" @click="deleteRule(ruleData.idx)">
          <i class="el-icon-delete" style="font-size:18px"></i>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    ruleData: { type: Array, required: false }, //群組規則數據 {id, groupId, ruleField, ruleOperator, ruleValue, idx}
    ruleOptions: { type: Array, required: true }, //群組規則選項 {id, fieldCode, fieldName, fieldOperator, fieldType}
    accountTags: { type: Array, required: false }, //帳戶標記選項 {key, value}
    accountLevels: { type: Array, required: false }, //帳戶級別選項 {key, value}
    accountStatuses: { type: Array, required: false }, //帳戶狀態選項 {key, value}
    registerSources: { type: Array, required: false }, //開户來源 {key, value}
    businessTypes: { type: Array, required: false }, //業務名稱 {key, value}
  },
  data() {
    return {
      ruleOperators: [], //群組規則運算 {key, value}
      showRuleValue: false,
      ruleValueType: "",
      annotationTxt: "",
    };
  },
  methods: {
    changeRuleField(val) {
      const objRule = this.ruleOptions.find((item)=>{
        return item.fieldCode === val
      })
      const operatorList = Object.entries(JSON.parse(objRule.fieldOperator))
      this.ruleOperators = operatorList.map(([key, value]) => ({ key: key, value: value }))
      this.ruleValueType = objRule.fieldType

      // clear selected value if the option no more valid
      if (this.ruleData.ruleOperator) {
        const isValid = this.ruleOperators.some(item => item.key === this.ruleData.ruleOperator)
        if (!isValid) {
          this.ruleData.ruleOperator = null
          this.ruleData.ruleValue = ""
          this.ruleData.ruleValues = []
          this.showRuleValue = false
          this.annotationTxt = ""
        }
      }

      // clear all multiple selected values if any selected value no more valid
      if (this.ruleData.ruleValues) {
        if (this.ruleData.ruleField == "accountTag") {
          for (let i = 0; i < this.ruleData.ruleValues.length; i++) {
            const isValid = this.accountTags.some(item => item.key === this.ruleData.ruleValues[i])
            if (!isValid) {
              this.ruleData.ruleValues = []
              break
            }
          }
        } else if (this.ruleData.ruleField == "accountLevel") {
          for (let i = 0; i < this.ruleData.ruleValues.length; i++) {
            const isValid = this.accountLevels.some(item => item.key === this.ruleData.ruleValues[i])
            if (!isValid) {
              this.ruleData.ruleValues = []
              break
            }
          }
        } else if (this.ruleData.ruleField == "accountStatus") {
          for (let i = 0; i < this.ruleData.ruleValues.length; i++) {
            const isValid = this.accountStatuses.some(item => item.key === this.ruleData.ruleValues[i])
            if (!isValid) {
              this.ruleData.ruleValues = []
              break
            }
          }
        } else if (this.ruleData.ruleField == "registerSource") {
          for (let i = 0; i < this.ruleData.ruleValues.length; i++) {
            const isValid = this.registerSources.some(item => item.key === this.ruleData.ruleValues[i])
            if (!isValid) {
              this.ruleData.ruleValues = []
              break
            }
          }
        } else if (this.ruleData.ruleField == "businessType") {
          for (let i = 0; i < this.ruleData.ruleValues.length; i++) {
            const isValid = this.businessTypes.some(item => item.key === this.ruleData.ruleValues[i])
            if (!isValid) {
              this.ruleData.ruleValues = []
              break
            }
          }
        } else {
          this.ruleData.ruleValues = []
        }
      }
    },

    changeRuleOperator(val) {
      if (val == null || val === "Y" || val === "N") {
        this.ruleData.ruleValue = ""
        this.ruleData.ruleValues = []
        this.showRuleValue = false
      } else {
        this.showRuleValue = true
      }

      if (this.ruleValueType == "" || this.ruleValueType == "str") {
        if (val === "IN" || val === "NI") {
          this.annotationTxt = "(可用逗号分隔, null=未填入)"
        } else if (val === "LK" || val === "NL") {
          this.annotationTxt = "(可用*号代表模糊部份)"
        } else {
          this.annotationTxt = ""
        }
      } else {
        this.annotationTxt = ""
      }
    },

    deleteRule(idx) {
      this.$emit("deleteRule", idx)
    },
  },
  watch: {
    'ruleData.ruleField': {
      handler(newValue, oldValue) {
        if (newValue) {
           this.changeRuleField(newValue)
        }
      },
      immediate: true 
    },
    'ruleData.ruleOperator': {
      handler(newValue, oldValue) {
        if (newValue) {
           this.changeRuleOperator(newValue)
        }
      },
      immediate: true 
    },
  },
};
</script>

<style lang="scss" scoped>
.border {
  margin-bottom: 15px;
  ul {
    display: flex;
    align-items: center;
    list-style-type: none;

    li {
      margin-right: 20px;

      .el-select, .el-input-number, .el-input {
        width: 180px;
      }

      &.is-long {
        flex: 1;
        display: flex;
        .el-select, .el-input-number, .el-input {
          width: 100%;
          min-width: 180px;
        }
      }
    }
  }
}
.icon-area {
  text-align: center;
}
</style>
